export class BaseSheet {
  sheet_code: string
  nendo: number
  month: number
  name: string
  sheet_content: string
  curriculum_id: number
  grade: number
  level: string
  times: number
  event_code: number
  rotate_angle: number

  constructor(baseSheet: any){
    this.sheet_code = baseSheet.sheet_code;
    this.nendo = baseSheet.nendo;
    this.month = baseSheet.month;
    this.name = baseSheet.name;
    this.sheet_content = baseSheet.sheet_content;
    this.curriculum_id = baseSheet.curriculum_id;
    this.grade = baseSheet.grade;
    this.level = baseSheet.level;
    this.times = baseSheet.times;
    this.event_code = baseSheet.event_code;
    this.rotate_angle = baseSheet.rotate_angle;
  }
}